import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import classNames from 'classnames';
import Loadable from 'react-loadable';

import {connect} from '@stubhub/react-store-provider';

import {showSaudiArabiaVATSelector} from './selectors';

import '../styles/index.scss';

const MerchHeader = Loadable({
  loader: () => import(/* webpackChunkName: "swi-MerchHeader" */ '@stubhub/react-merch-header'),
  loading: () => null,
});

const EventMerchHeader = Loadable({
  loader: () => import(/* webpackChunkName: "swi-EventHeader" */ '@stubhub/react-event-merch-header'),
  loading: () => null,
});

const SimpleHeader = Loadable({
  loader: () => import(/* webpackChunkName: "swi-SimpleHeader" */ '@stubhub/react-simple-header'),
  loading: () => null,
});

const FooterNew = Loadable({
  // eslint-disable-next-line import/no-unresolved
  loader: () => import(/* webpackChunkName: "swi-FooterNew" */ '@stubhub/react-footer-new'),
  loading: () => null,
});

const reHome = /^\/([a-z]{2}\/?)?$/i;
const reCategory = /\/category\/(1|28|174)\//i;
const rePerformer = /\/performer\//i;
const reGeography = /\/geography\//i;
const reVenue = /\/venue\//i;
const reLangSel = /^\/(fr|de|es)(\/find\/s)?\/$/i;

function mapStateToProps(state) {
  const deviceState = state.device || {};
  const entityConfig = state['app.entity'] || {};
  let entityType = entityConfig.entity ? entityConfig.entity.performerType : null;

  if (!entityType && entityConfig.entity && entityConfig.entity.isArtist) {
    entityType = 'Artist';
  }

  return {
    deviceType: deviceState?.type,
    entityType,
    showSaudiArabiaVAT: showSaudiArabiaVATSelector(state),
  };
}

class UnifiedLayout extends Component {
  state = {
    isMenuActive: false,
  };

  componentDidMount() /* istanbul ignore next */ {
    const {scrollToAnchorRef} = this;

    /**
     * Scroll To Top of the Page on Navigation.
     *
     */

    if (scrollToAnchorRef && typeof scrollToAnchorRef.scrollIntoView === 'function') {
      scrollToAnchorRef.scrollIntoView({behavior: 'smooth'});
    }
  }

  onNavMenuStateChange = (isMenuActive) => {
    this.setState({isMenuActive});
  };

  render() {
    const {
      showSellTicketHeader,
      searchBarStyle,
      showMerchHeader,
      showEventMerchHeader,
      showFooter,
      location,
      deviceType,
      entityType,
      showGoogleSemMessage,
      showSaudiArabiaVAT,
      children,
    } = this.props;
    const {onNavMenuStateChange} = this;
    const {globalRegistry} = this.context;
    const {isMenuActive} = this.state;
    let footer;
    let header;
    let noNavSecondary;
    let searchpage;
    const isMobile = deviceType === 'phone' || deviceType === 'tablet';
    const isArtist = entityType === 'Artist';
    const artistRedesignEnabled = globalRegistry.getFeatureValue('performer.artistRedesignEnabled');
    const performerDateFilter = artistRedesignEnabled && isArtist;

    const homepage = location && reHome.test(location.pathname);
    const categorypage = location && reCategory.test(location.pathname);
    const performerpage = location && rePerformer.test(location.pathname) && performerDateFilter;
    const geographypage = location && reGeography.test(location.pathname);
    const venuepage = location && reVenue.test(location.pathname);

    if (location && location.pathname === '/find/s/') {
      searchpage = true;
    }

    if (isMobile && (homepage || categorypage)) {
      noNavSecondary = true;
    }

    const langSelector = location && reLangSel.test(location.pathname);

    if (showMerchHeader && globalRegistry && globalRegistry.getFeatureValue('common.enableMerchHeader')) {
      const props = {
        searchBarStyle,
        onNavMenuStateChange,
        homepage,
        searchpage,
        categorypage,
        performerpage,
        geographypage,
        venuepage,
        langSelector,
        noNavSecondary,
        isSearchAutoFocus: homepage,
        showGoogleSemMessage,
      };
      header = <MerchHeader {...props} />;
    } else if (showEventMerchHeader && globalRegistry && globalRegistry.getFeatureValue('event.enableEventHeader')) {
      header = <EventMerchHeader searchBarStyle={searchBarStyle} onNavMenuStateChange={onNavMenuStateChange} />;
    } else if (!showMerchHeader && showSellTicketHeader) {
      header = <SimpleHeader />;
    } else if (!showMerchHeader && !showEventMerchHeader) {
      header = null;
    }

    if (showFooter && globalRegistry && globalRegistry.getFeatureValue('homepage.enableNewFooter')) {
      footer = <FooterNew isHomepage={homepage} showSaudiArabiaVAT={showSaudiArabiaVAT} />;
    } else {
      footer = null;
    }

    return (
      <div ref={/* istanbul ignore next */ (node) => (this.scrollToAnchorRef = node)}>
        {header}
        <div
          className={classNames('UnifiedLayout__mainContainer', {
            'UnifiedLayout__mainContainer--menuActive': isMenuActive,
          })}
        >
          <main id="main">{children}</main>
          {footer}
        </div>
      </div>
    );
  }
}

UnifiedLayout.propTypes = {
  /** The style of the search bar */
  searchBarStyle: PropTypes.oneOf(['expanded', 'modal']),

  /** Whether Saudi Arabia VAT logo should be shown*/
  showSaudiArabiaVAT: PropTypes.bool,

  location: PropTypes.object,

  /** Whether to show the merch header */
  showMerchHeader: PropTypes.bool,

  /** Whether to show the sell ticket header */
  showSellTicketHeader: PropTypes.bool,

  /** Whether to show the event merch header */
  showEventMerchHeader: PropTypes.bool,

  /** Whether to show the footer */
  showFooter: PropTypes.bool,

  /** The type of device */
  deviceType: PropTypes.string,

  /** The type of entity */
  entityType: PropTypes.string,

  /** Whether to show the google SEM message */
  showGoogleSemMessage: PropTypes.bool,

  /** The children */
  children: PropTypes.node,
};

UnifiedLayout.defaultProps = {
  searchBarStyle: 'expanded',
};

UnifiedLayout.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default connect({mapStateToProps})(UnifiedLayout);
